import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@lms/ui/tooltip';
import type React from 'react';

interface Props {
  className?: string;
}

// Ported from the Next app's components/ellipsis-span.tsx.
const EllipsisSpan: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  ...props
}) => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger {...props}>
        <span className="line-clamp-1 text-left break-all">{children}</span>
      </TooltipTrigger>
      <TooltipContent>
        <p>{children}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

EllipsisSpan.displayName = 'EllipsisSpan';
export default EllipsisSpan;
